// extracted by mini-css-extract-plugin
export default {"purposeToIndustryLabel":"AccountInformation_purposeToIndustryLabel__gQNWl"};